import { find, isNil, some } from "lodash";
import { PaymentStatus } from "../../PaymentContainerClient/commons/enums";
import InstallmentDto from "../../PaymentContainerClient/dtos/InstallmentDto";
import PaymentDto from "../../PaymentContainerClient/dtos/PaymentDto";
import getInstallmentsSortedByDueDate from "./getInstallmentsSortedByDueDate";

export default function getFirstScheduledInstallment(
    installments: InstallmentDto[],
    payments: PaymentDto[]
): InstallmentDto | undefined {
    return find(getInstallmentsSortedByDueDate(installments), (installment) => {
        return !isNil(
            find(
                payments,
                (payment) =>
                    some(
                        payment.installmentIds,
                        (installmentId) => installmentId === installment.id
                    ) && payment.status === PaymentStatus.Scheduled
            )
        );
    });
}
